"use strict";import{tag as o}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const GlobeGridIcon=({width:e=24,height:t=24,hidden:r=!1,title:l="Globe Grid"}={})=>o`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${e}"
    height="${t}"
    viewBox="0 0 20 20"
    aria-hidden=${r?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${l}"
  >
    <path
      d="M10,1.25195C5.1748,1.25195,1.25,5.17676,1.25,10.00195s3.9248,8.75,8.75,8.75,8.75-3.9248,8.75-8.75S14.8252,1.25195,10,1.25195ZM17.21094,9.25195h-3.14209c-.1394-2.33032-.91455-4.52637-2.19165-6.24487,2.85547.76733,5.02271,3.2312,5.33374,6.24487ZM10.01245,16.8833c-1.4895-1.53711-2.41895-3.74487-2.58203-6.13135h5.13916c-.16138,2.38818-1.08105,4.59326-2.55713,6.13135ZM7.43066,9.25195c.16284-2.38745,1.0918-4.59399,2.5813-6.13184,1.47681,1.5376,2.39624,3.74292,2.55762,6.13184h-5.13892ZM8.14624,3.00098c-1.28979,1.72021-2.07397,3.91919-2.21509,6.25098h-3.14209c.31177-3.02197,2.49023-5.49072,5.35718-6.25098ZM2.78906,10.75195h3.14209c.14111,2.33081.92627,4.53027,2.21606,6.25098-2.86768-.75977-5.04614-3.22876-5.35815-6.25098ZM11.87671,16.99683c1.27734-1.71924,2.05273-3.91528,2.19238-6.24487h3.14185c-.31104,3.01392-2.47852,5.47778-5.33423,6.24487Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
//# sourceMappingURL=GlobeGrid.js.map
